// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__upri9","type":"styles_type__2t_NE","choices":"styles_choices__2KWfN"};